var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UniversalFinalizationRegistry } from "./UniversalFinalizationRegistry.util";
export default class InvertedWeakMap extends Map {
    constructor(onFinalizeCallback) {
        super();
        this.registry = new UniversalFinalizationRegistry((key) => __awaiter(this, void 0, void 0, function* () {
            this.delete(key);
            try {
                if (onFinalizeCallback)
                    yield onFinalizeCallback(key);
            }
            catch (e) {
                //     ignore
            }
        }));
    }
    set(key, value) {
        this.registry.register(value, key);
        return super.set(key, new WeakRef(value));
    }
    get(key) {
        const _super = Object.create(null, {
            get: { get: () => super.get }
        });
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            return (_a = _super.get.call(this, key)) === null || _a === void 0 ? void 0 : _a.deref();
        });
    }
    has(key) {
        return super.has(key);
    }
    presented(key) {
        const _super = Object.create(null, {
            has: { get: () => super.has }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.has.call(this, key) && (yield this.get(key)) !== undefined;
        });
    }
    delete(key) {
        const ref = super.get(key);
        if (ref) {
            const deref = ref.deref();
            if (deref)
                this.registry.unregister(deref);
            return super.delete(key);
        }
        return false;
    }
}
//# sourceMappingURL=invertedWeakMap.util.js.map